import sectionsRef from "@models/interactions/sections-ref";
import LegalLayout from "@components/templates/legal-layout";


export default function CookiesPolicy() {
  const { model, operations } = sectionsRef(6);

  return (
    <LegalLayout>
      <main className="w-full flex flex-col text-white px-4 max-w-[900px] mt-[60px] pb-5">
        <h2 className="text-4xl text-center">Cookies Policy</h2>
        <span className="text-center">COOKIES POLICY</span>
        <div className="flex flex-col text-white mt-10 gap-2 text-xl">
          <span>
            1.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[0]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              INTRODUCTION
            </a>
          </span>
          <span>
            2.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[1]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              COOKIES USED ON THIS SITE
            </a>
          </span>
          <span>
            3.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[2]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              THIRD PARTY WEBSITES’ COOKIES.
            </a>
          </span>
          <span>
            4.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[3]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              HOW TO MANAGE YOUR COOKIE PREFERENCES
            </a>
          </span>
          <span>
            5.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[4]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              CONTACTING US
            </a>
          </span>
          <span>
            6.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[5]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              CHANGES TO THE POLICY
            </a>
          </span>
        </div>

        <article className="flex w-full flex-col justify-start gap-[18px] lg:w-[916px] text-white mt-4">
          <section ref={model.refs[0]} className="flex flex-col gap-5 text-white">
            <h5>1. INTRODUCTION</h5>
            <span className="flex flex-col gap-2 text-white">
              <strong>1.1 PURPOSE OF POLICY  </strong>
              <p>From time to time, We may use the standard “cookies” feature of major
                 browser applications or other typical mobile equivalents that allows 
                 Us to store a small piece of data on your device about your visit to 
                 our Site.  We use cookies and/or similar technologies to analyze customer
                behavior, administer the Site, track users’ movements, and to collect 
                information about users. This is done in order to personalize and enhance
                your experience with Us.  We do not set any personally identifiable 
                information in cookies, nor do We employ any data capture mechanisms on 
                Our Site other than cookies.
                </p>
                <p>This cookies policy (“Policy”) provides you with information about cookies
                and how to control them while using Our Site.  Any capitalized terms used
                but not defined herein has the respective meanings given to them in 
                the <a className="text-blue-700 hover:underline" href="https://memod.com/legal/terms-of-service">
                Terms of Service</a>, <a className="text-blue-700 hover:underline" 
                href="https://memod.com/founders/program-terms-of-service">Terms of Use for the Founder Creator Program</a>, 
                or the <a className="text-blue-700 hover:underline" href="https://memod.com/legal/privacy-policy">Privacy
                Policy.</a></p>
                
                <strong>1.2  WHAT IS A COOKIE?</strong>


                 A cookie is a small text file that is stored on your computer or mobile device.
                   Cookies store information used to make sites work.  Only We can access the cookies created by
                    Our Site.  You can control your cookies at the browser level.
                   Disabling cookies may restrict or affect your use of certain functions.
            </span>
          </section>
          <section ref={model.refs[1]} className="flex flex-col gap-5 ">
            <h5>2. COOKIES USED ON THIS SITE</h5>
            <span className="flex flex-col gap-2 text-white">
              <strong>2.1 ESSENTIAL COOKIES </strong>
              <p> These cookies are essential for enabling user movement around Our Site and providing access to 
                features such as your profile, purchases, members-only resources, and other secure areas of the Site.
                These cookies do not gather personal information about you that could be used for marketing purposes
                and do not remember where you have been on the internet.  This category of cookies cannot be disabled.</p>
            </span>
            <span className="flex flex-col gap-2 text-white">
              <strong>2.2 PERFORMANCE COOKIES</strong>

              <p>These cookies collect information about how visitors use Our Services
                 in order to improve how Our Services perform, such as which pages visitors 
                 frequent most often and if they receive error messages from web pages. 
                  These cookies collect anonymous information on the pages visited. 
                   All information these cookies collect is aggregated and therefore anonymous.</p>
            </span>
            <span className="flex flex-col gap-2 text-white">
              <strong>2.3 FUNCTIONALITY COOKIES</strong>

              <p>
                These cookies provide functionality that makes Our Service more convenient and makes providing more 
                personalized features possible by remembering choices you make within Our Site.
                These cookies provide you with a more personal experience and stores your preferences
                so you do not need to reenter or reselect them every time you visit Our Site.
              </p>
            </span>
            <span className="flex flex-col gap-2 text-white">
              <strong>2.4 ANALYTICS COOKIES</strong>
              <p>We use Google Analytics cookies to collect information about how visitors use Our Site.
                These cookies collect information in the aggregate to give Us insight into how Our
                Site is being used.  We anonymize IP addresses in Google Analytics, and the anonymized
                data is transmitted to and stored by Google on servers in the United States.
                Google may also transfer this information to third parties where required to do so
                by law, or where such third parties process the information on Google’s behalf.
                Google will not associate your IP address with any other data held by Google. <a className="text-blue-700 hover:underline"
                 onClick={() => {
                  operations.scrollToRef(model.refs[0]);
                }}>[a]</a> 
              </p>
            </span>
            <span className="flex flex-col gap-2 text-white">
              <strong>2.4 TARGETED AND ADVERTISING COOKIES</strong>

              <p>These cookies collect information about your browsing habits in order to deliver advertisements 
              relevant to you and your interests.  These cookies are also used to limit the number of times you
              see an advertisement as well as help measure the effectiveness of the advertising campaigns.
              They are usually placed by advertising networks with Our permission.  These cookies remember that
              you have visited a website and this information may be shared with other organizations such 
              asadvertisers. Targeted or advertising cookies are often linked to site functionality provided
              by other organizations.</p>
            </span>
            <span className="flex flex-col gap-2 text-white">
              <strong>2.5 SOCIAL MEDIA COOKIES</strong>
              <p>These cookies are used when you share information using a social media sharing button
                or “like” button on Our Site or if you link your account or engage with Our Services
                on or through a social networking website such as Facebook, Twitter, or Instagram.
              </p>
            </span>
          </section>
          <section ref={model.refs[2]} className="flex flex-col gap-5 text-white">
              <span>
                <strong>3. THIRD PARTY WEBSITES’ COOKIES</strong>
                <p>Third party cookies are cookies set by someone other than Us for purposes such as collecting information
                on user behavior, demographics, or personalized marketing.  When using Our Site, you may encounter
                embedded content or you may be directed to other websites.  These websites and embedded content may
                use their own cookies.  We do not have control over the placement of cookies by other websites.
                </p>
              </span>
          </section>
          <section ref={model.refs[3]} className="flex flex-col gap-5 text-white">
            <h5>4. HOW TO MANAGE YOUR COOKIE PREFERENCES</h5>
            <span>
              <p><strong>4.1 BROWSER COOKIES </strong> You may withdraw or modify your consent to Our
                use of cookies at any time by adjusting your browser settings.
                To do so, follow the instructions provided by your browser to
                change your settings (usually located within the “Help”, “Tools”, or “Edit” setting).
                Please note that by disabling cookies, you may not be able to access all the features
                of Our Site or may experience some inconvenience when using Our Site.
              </p>
            </span>
            <span>
              <strong>4.2 MOBILE IDENTIFIERS</strong>
              <p>On your mobile device, your operating system may provide you with additional options
               to opt out of interest-based advertising or to otherwise reset your mobile identifiers.
              </p>
            </span>
          </section>
          <section ref={model.refs[4]} className="flex flex-col gap-5 text-white">
            <p><strong>5. CONTACTING US</strong> If you have any questions about this Policy,
              please contact us at [<a href="mailto:legal@memod.com" className=" text-blue-700 hover:underline">legal@memod.com</a>].
            </p>
          </section>
          <section ref={model.refs[5]} className="flex flex-col gap-5 text-white">
            <p><strong>6. CHANGES TO THE POLICY</strong> We reserve the right, at any time, to add to, change, update,
            supplement, or modify this Policy.
            </p>
            <p><a className="text-blue-700 hover:underline"
              onClick={() => {
                operations.scrollToRef(model.refs[0]);
              }}>[a]</a> Confirm Google Analytics and whether there are any other third
              parties collecting information through cookies from our site.</p>
          </section>
          
        </article>

      </main>
    </LegalLayout>
  );
}
